import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Loading from "../../../components/isLoading";
import TableView from "../../../components/Table/TableView";
// import { fetchUsersData } from "../../../redux/users/index";
import { fetchSubscribers } from "../../../redux/subscriptions";
import ListItemMenu from "../../../components/Menu/ListItemMenu";
import apiService from "../../../services/apiService";
import Toast from "../../../components/MessageToast";
import ConfirmationDialog from "../../../components/Dialogs/ConfirmationDialog";

export default () => {
  const usersData = useSelector((state) => state.users);
  const subscribers = useSelector(store => store.subscribersGlobalStore);
  console.log(subscribers, "these are the subscribers");
  const dispatch = useDispatch();

  const [state, setState] = useState({
    model: false,
  });

  useEffect(() => {
    dispatch(fetchSubscribers(0));
  }, []);

  const toggleModel = (action) => {
    if(action.removeSubscriber) {
      console.log(action, "your actions");
      setState({
        ...state,
        subscriber: action.subscriber,
        confirmModel: true,
        confirmTitle: "confirm unsubscribe",
        confirmMessage:`Are you sure you want to remove ${action.subscriber.email} from BRAC`,
        danger: true,
        confirmText: "Unsubscribe",
        removeSubscriber: action.removeSubscriber
      })
      console.log(state, "== these are ");
    }else{
      setState({
        ...state,
        model: false,
        subscriber:null,
        confirmModel: false,
        removeSubscriber: false
      })
    }
  }

  const onConfirm = () =>{
    if(state.removeSubscriber) onRemoveSubscriber();
  }
  const onRemoveSubscriber = async() =>{
    setState((prev) => ({...prev, loading:true}));
    const response = await apiService({
      method:"DELETE",
      path: `/api/subscribers/${state.subscriber?.id}`
    });
    Toast({
      message: response.message,
      type: response.error ? "error" : "success",
      duration:5000,
      onClose: () => {
        setState((prev) => ({...prev, loading: false}));
        toggleModel({});
        if(!response.error) dispatch(fetchSubscribers());
      }
    })
  }

  const headCells = [
    {
      id: "firstName",
      numeric: false,
      label: "First Name",
    },
    {
      id: "lastName",
      numeric: false,
      label: "Last Name",
    },
    {
      id: "email",
      numeric: false,
      label: "Email",
    },
    {
      id: "country",
      numeric: false,
      label: "Country",
    },
    {
      id: "state",
      numeric: false,
      label: "State",
    },
    {
      id: "action",
      numeric: false,
      label: "Action",
    },
  ];

  const rows =
    subscribers.data.data?.map((el) => ({
      fistName: el.firstName,
      lastName: el.lastName,
      email: el.email,
      country: el.country,
      state: el.state || "Not set",
      action: (
        <ListItemMenu
          menu={[
            {
              primary:"unsubscribe",
              onClick: () => toggleModel({
                subscriber:el,
                removeSubscriber:true
              })
            },
          ]}
        />
      ),
    })) || [];

  return (
    <div>
      {usersData.loading && !usersData.data[0] ? (
        <Loading />
      ) : (
        <>
          <div>
            <TableView
              dense
              headCells={headCells}
              rows={rows}
              title="BRAC Subscribers"
            />
          </div>
        </>
      )}

      <ConfirmationDialog
        open={state.confirmModel || false}
        title={state.confirmTitle}
        message={state.confirmMessage}
        confirmText={state.confirmText}
        danger={state.danger}
        onCancel={() => toggleModel({})}
        onConfirm={onConfirm}
        loading={state.loading}
      />
    </div>
  );
};
